/**
 * Order tracking page (sections/ryze-order-tracking.liquid).
 *
 * Looks a shipment up through the ryze-shipment-tracking worker, which proxies Wonderment:
 *   POST {apiUrl}/api/tracking/{searchTerm}?t={base64({"email": ...})}
 * Wonderment only returns an order when the email matches it.
 */
(function () {
  if (window.RyzeOrderTracking) return;
  window.RyzeOrderTracking = true;

  var STEPS = ['Packed', 'On its way', 'Out for delivery', 'Delivered'];
  var VISIBLE_EVENTS = 3;
  var ISSUE_STATUSES = ['FAILURE', 'RETURNED'];

  var ICONS = {
    box: '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false"><path d="M21 8L12 3L3 8M21 8L12 13M21 8V16L12 21M12 13L3 8M12 13V21M3 8V16L12 21" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    truck: '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false"><path d="M14 17V6H2V17H4M14 17H9M14 17H15M14 9H18L22 13V17H20M9 17C9 18.1 8.1 19 7 19C5.9 19 5 18.1 5 17C5 15.9 5.9 15 7 15C8.1 15 9 15.9 9 17ZM20 17C20 18.1 19.1 19 18 19C16.9 19 16 18.1 16 17C16 15.9 16.9 15 18 15C19.1 15 20 15.9 20 17Z" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    pin: '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false"><path d="M12 21C12 21 19 15 19 9.5C19 5.36 15.87 2 12 2C8.13 2 5 5.36 5 9.5C5 15 12 21 12 21Z" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/><circle cx="12" cy="9.5" r="2.5" stroke="currentColor" stroke-width="1.8"/></svg>',
    check: '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false"><path d="M5 12.5L10 17.5L19 7" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    alert: '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false"><path d="M12 8V13M12 16.5V16.4M10.3 3.9L2.4 17.6C1.6 18.9 2.6 20.5 4.1 20.5H19.9C21.4 20.5 22.4 18.9 21.6 17.6L13.7 3.9C12.9 2.6 11.1 2.6 10.3 3.9Z" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    copy: '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false"><rect x="8" y="8" width="13" height="13" rx="2.5" stroke="currentColor" stroke-width="1.8"/><path d="M16 8V5.5C16 4.12 14.88 3 13.5 3H5.5C4.12 3 3 4.12 3 5.5V13.5C3 14.88 4.12 16 5.5 16H8" stroke="currentColor" stroke-width="1.8"/></svg>',
    external: '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false"><path d="M14 4H20V10M20 4L11 13M18 14V18.5C18 19.33 17.33 20 16.5 20H5.5C4.67 20 4 19.33 4 18.5V7.5C4 6.67 4.67 6 5.5 6H10" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    back: '<svg viewBox="0 0 24 24" fill="none" width="18" height="18" aria-hidden="true" focusable="false"><path d="M19 12H5M5 12L12 19M5 12L12 5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>'
  };

  function escapeHtml(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  // "1234" or "#1234" → "RYZE1234" (order names are #RYZE…); long digit strings are tracking numbers.
  function normalizeSearchTerm(value) {
    var term = value.replace(/\s+/g, '').toUpperCase();
    var digits = term.replace(/^#/, '');
    return /^\d{1,10}$/.test(digits) ? 'RYZE' + digits : term;
  }

  function isEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
  }

  // Carrier dates come without a reliable timezone; show the wall-clock time as written.
  function parseDate(value) {
    var m = /^(\d{4})-(\d{2})-(\d{2})(?:T(\d{2}):(\d{2}))?/.exec(value || '');
    if (!m) return null;
    return {
      date: new Date(+m[1], +m[2] - 1, +m[3], +(m[4] || 0), +(m[5] || 0)),
      hasTime: m[4] !== undefined && !/T00:00:00/.test(value)
    };
  }

  function formatDay(parsed, long) {
    return parsed.date.toLocaleDateString('en-US', { weekday: long ? 'long' : 'short', month: 'short', day: 'numeric' });
  }

  // Some carriers send "ArrivedAtCarrierFacility" — split it into a sentence. Text with spaces is kept as sent.
  function formatDetails(value) {
    var text = String(value || '').trim();
    if (!/^[A-Za-z]+$/.test(text) || !/[a-z][A-Z]/.test(text)) return text;
    text = text.replace(/([a-z])([A-Z])/g, '$1 $2').toLowerCase();
    return text.charAt(0).toUpperCase() + text.slice(1);
  }

  // "Memphis Tn Us" / "Plaistow, Nh 03865" / "Bethlehem, PA, US" → "Memphis, TN"
  function formatLocation(value) {
    var parts = String(value || '').replace(/,/g, ' ').trim().split(/\s+/).filter(Boolean);
    if (/^us(a)?$/i.test(parts[parts.length - 1] || '')) parts.pop();
    if (/^\d{5}(-\d{4})?$/.test(parts[parts.length - 1] || '')) parts.pop();
    if (parts.length > 1 && /^[a-z]{2}$/i.test(parts[parts.length - 1])) {
      var state = parts.pop().toUpperCase();
      return parts.join(' ') + ', ' + state;
    }
    return parts.join(' ');
  }

  function formatDateTime(parsed) {
    var day = formatDay(parsed, false);
    if (!parsed.hasTime) return day;
    return day + ' · ' + parsed.date.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' });
  }

  function startOfToday() {
    var now = new Date();
    return new Date(now.getFullYear(), now.getMonth(), now.getDate());
  }

  function shipmentState(shipment) {
    var details = shipment.statusDetails || {};
    var status = (details.status || '').toUpperCase();
    var substatus = (details.substatus || '').toLowerCase();

    if (ISSUE_STATUSES.indexOf(status) !== -1) {
      return { step: -1, issue: true, icon: 'alert', title: status === 'RETURNED' ? 'Returned to sender' : 'Delivery issue' };
    }
    if (status === 'DELIVERED') return { step: 3, icon: 'check', title: 'Delivered' };
    if (substatus.indexOf('out_for_delivery') !== -1) return { step: 2, icon: 'pin', title: 'Out for delivery' };
    if (status === 'TRANSIT') return { step: 1, icon: 'truck', title: 'On its way' };
    if (status === 'PRE_TRANSIT') return { step: 0, icon: 'box', title: 'Packed and ready' };
    return { step: 0, icon: 'box', title: 'Awaiting carrier update' };
  }

  function statusMeta(shipment, state) {
    var details = shipment.statusDetails || {};
    var location = formatLocation(details.locationDisplay);
    var latest = parseDate(details.date);
    var eta = parseDate(shipment.eta || details.eta);

    if (state.step === 3 && latest) {
      return '<strong>' + escapeHtml(formatDay(latest, true)) + '</strong>' + (location ? ' · ' + escapeHtml(location) : '');
    }
    if (state.issue) {
      return escapeHtml(formatDetails(details.details) || 'The carrier reported a problem with this package.');
    }
    if (state.step === 2) {
      return '<strong>Arriving today</strong>' + (location ? ' · ' + escapeHtml(location) : '');
    }
    if (eta && eta.date >= startOfToday()) {
      return 'Estimated delivery <strong>' + escapeHtml(formatDay(eta, true)) + '</strong>';
    }
    if (state.step === 0) {
      return 'Waiting for the carrier to pick it up.';
    }
    return latest ? 'Last update ' + escapeHtml(formatDateTime(latest)) : '';
  }

  function renderProgress(state) {
    if (state.issue) return '';
    var fill = state.step / (STEPS.length - 1);
    var steps = STEPS.map(function (label, i) {
      var cls = 'ryze-track__step';
      if (i <= state.step) cls += ' ryze-track__step--done';
      if (i === state.step && i < STEPS.length - 1) cls += ' ryze-track__step--current';
      return '<li class="' + cls + '"' + (i === state.step ? ' aria-current="step"' : '') + '>' + label + '</li>';
    }).join('');
    return '<ol class="ryze-track__progress" data-fill="' + fill + '" aria-label="Shipment progress">' + steps + '</ol>';
  }

  function renderCarrier(shipment) {
    var code = shipment.trackingCode;
    if (!code) return '';
    var url = shipment.trackingUrl || (shipment.statusDetails || {}).trackingUrl;
    var link = /^https?:\/\//.test(url || '')
      ? '<a class="ryze-track__carrier-link" href="' + escapeHtml(url) + '" target="_blank" rel="noopener">Carrier site ' + ICONS.external + '</a>'
      : '';
    return (
      '<div class="ryze-track__carrier">' +
        '<div class="ryze-track__carrier-info">' +
          '<span class="ryze-track__carrier-name">' + escapeHtml(shipment.carrierName || 'Tracking number') + '</span>' +
          '<button type="button" class="ryze-track__code" data-copy="' + escapeHtml(code) + '" aria-label="Copy tracking number ' + escapeHtml(code) + '">' +
            '<span>' + escapeHtml(code) + '</span>' + ICONS.copy +
          '</button>' +
        '</div>' +
        link +
      '</div>'
    );
  }

  function renderItems(items, title) {
    if (!items || !items.length) return '';
    var rows = items.map(function (item) {
      var image = item.variantImage || item.productImage;
      var variant = item.variantName && !/default title/i.test(item.variantName) ? item.variantName : '';
      var qty = escapeHtml(item.quantity || 1);
      return (
        '<li class="ryze-track__item">' +
          (image
            ? '<img class="ryze-track__item-image" src="' + escapeHtml(image) + '" alt="" width="64" height="64" loading="lazy">'
            : '') +
          '<span class="ryze-track__item-name">' + escapeHtml(item.productName || item.name || 'Item') +
            (variant ? '<span>' + escapeHtml(variant) + '</span>' : '') +
          '</span>' +
          '<span class="ryze-track__item-qty" aria-label="Quantity ' + qty + '">×' + qty + '</span>' +
        '</li>'
      );
    }).join('');
    return '<div><h3 class="ryze-track__section-title">' + title + '</h3><ul class="ryze-track__items">' + rows + '</ul></div>';
  }

  function renderTimeline(shipment, index) {
    var events = (shipment.events || []).slice().sort(function (a, b) {
      return String(b.date).localeCompare(String(a.date));
    });
    if (!events.length) return '';
    var rows = events.map(function (event, i) {
      var parsed = parseDate(event.date);
      var meta = [parsed ? formatDateTime(parsed) : '', formatLocation(event.locationDisplay)].filter(Boolean).join(' · ');
      return (
        '<li class="ryze-track__event"' + (i >= VISIBLE_EVENTS ? ' hidden' : '') + '>' +
          '<span class="ryze-track__event-title">' + escapeHtml(formatDetails(event.details || event.status)) + '</span>' +
          (meta ? '<span class="ryze-track__event-meta">' + escapeHtml(meta) + '</span>' : '') +
        '</li>'
      );
    }).join('');
    var id = 'RyzeTrackEvents-' + index;
    var toggle = events.length > VISIBLE_EVENTS
      ? '<button type="button" class="ryze-track__link-button" data-toggle-events aria-controls="' + id + '" aria-expanded="false">Show all ' + events.length + ' updates</button>'
      : '';
    return '<div><h3 class="ryze-track__section-title">Tracking history</h3><ol class="ryze-track__timeline" id="' + id + '">' + rows + '</ol>' + toggle + '</div>';
  }

  function renderShipment(shipment, index, total) {
    var state = shipmentState(shipment);
    var meta = statusMeta(shipment, state);
    var timeline = renderTimeline(shipment, index);
    var cls = 'ryze-track__card ryze-track__shipment';
    if (state.step === 3) cls += ' ryze-track__shipment--delivered';
    if (state.issue) cls += ' ryze-track__shipment--issue';

    return (
      '<article class="' + cls + '" style="animation-delay:' + index * 80 + 'ms">' +
        (total > 1 ? '<p class="ryze-track__package-label">Package ' + (index + 1) + ' of ' + total + '</p>' : '') +
        '<div class="ryze-track__status">' +
          '<span class="ryze-track__status-icon">' + ICONS[state.icon] + '</span>' +
          '<div class="ryze-track__status-text">' +
            '<h2 class="ryze-track__status-title">' + state.title + '</h2>' +
            (meta ? '<p class="ryze-track__status-meta">' + meta + '</p>' : '') +
          '</div>' +
        '</div>' +
        renderProgress(state) +
        (state.issue ? '<p class="ryze-track__notice">Check the carrier site for details, or contact our team and we\'ll sort it out.</p>' : '') +
        renderCarrier(shipment) +
        renderItems(shipment.lineItems, total > 1 ? 'In this package' : 'Items') +
        (timeline ? '<hr class="ryze-track__divider">' + timeline : '') +
      '</article>'
    );
  }

  function renderResults(data, searchTerm) {
    var shipments = data.shipments || [];
    var pending = data.pendingLineItems || [];
    var orderName = data.name || (shipments[0] && shipments[0].order && shipments[0].order.name) || searchTerm;
    var summary = shipments.length > 1
      ? shipments.length + ' packages'
      : shipments.length === 1 ? '1 package' : 'Not shipped yet';

    var html =
      '<div class="ryze-track__results-head">' +
        '<p class="ryze-track__order-name">Order ' + escapeHtml(orderName) + '<span>' + summary + '</span></p>' +
        '<button type="button" class="ryze-track__link-button" data-reset>' + ICONS.back + 'Track another order</button>' +
      '</div>';

    html += shipments.map(function (shipment, i) {
      return renderShipment(shipment, i, shipments.length);
    }).join('');

    if (pending.length || !shipments.length) {
      html +=
        '<div class="ryze-track__card ryze-track__shipment">' +
          '<div class="ryze-track__status">' +
            '<span class="ryze-track__status-icon">' + ICONS.box + '</span>' +
            '<div class="ryze-track__status-text">' +
              '<h2 class="ryze-track__status-title">' + (shipments.length ? 'Still to ship' : 'Getting your order ready') + '</h2>' +
              '<p class="ryze-track__status-meta">We\'ll email you tracking details as soon as ' + (shipments.length ? 'these ship' : 'it ships') + '.</p>' +
            '</div>' +
          '</div>' +
          renderItems(pending, 'Items') +
        '</div>';
    }
    return html;
  }

  function renderSkeleton() {
    return (
      '<div class="ryze-track__card ryze-track__skeleton" aria-hidden="true">' +
        '<span style="width:45%;height:28px"></span>' +
        '<span style="width:70%"></span>' +
        '<span style="width:100%;height:8px"></span>' +
        '<span style="width:60%"></span>' +
        '<span style="width:85%"></span>' +
      '</div>'
    );
  }

  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';

    var apiUrl = (root.dataset.apiUrl || '').replace(/\/+$/, '');
    var form = root.querySelector('[data-ryze-track-form]');
    var results = root.querySelector('[data-ryze-track-results]');
    var errorEl = root.querySelector('[data-ryze-track-error]');
    var orderInput = form.elements.order;
    var emailInput = form.elements.email;
    var controller = null;

    function showError(message, input) {
      errorEl.textContent = message;
      errorEl.hidden = false;
      [orderInput, emailInput].forEach(function (el) {
        if (el === input) el.setAttribute('aria-invalid', 'true');
        else el.removeAttribute('aria-invalid');
      });
      if (input) input.focus();
    }

    function clearError() {
      errorEl.hidden = true;
      errorEl.textContent = '';
      orderInput.removeAttribute('aria-invalid');
      emailInput.removeAttribute('aria-invalid');
    }

    function setBusy(busy) {
      form.setAttribute('aria-busy', busy ? 'true' : 'false');
    }

    function showForm() {
      results.hidden = true;
      results.innerHTML = '';
      form.hidden = false;
      updateUrl(null);
      orderInput.focus();
    }

    function updateUrl(order) {
      try {
        var url = new URL(window.location.href);
        url.searchParams.delete('email');
        if (order) url.searchParams.set('order', order);
        else url.searchParams.delete('order');
        window.history.replaceState(null, '', url);
      } catch (e) {}
    }

    function lookup() {
      clearError();
      var rawOrder = orderInput.value.trim();
      var email = emailInput.value.trim().toLowerCase();

      if (!rawOrder) return showError('Enter your order number.', orderInput);
      if (!isEmail(email)) return showError('Enter the email address you used at checkout.', emailInput);

      var searchTerm = normalizeSearchTerm(rawOrder);
      var token = btoa(JSON.stringify({ email: email }));

      if (controller) controller.abort();
      controller = 'AbortController' in window ? new AbortController() : null;

      setBusy(true);
      results.hidden = false;
      results.innerHTML = renderSkeleton();

      fetch(apiUrl + '/api/tracking/' + encodeURIComponent(searchTerm) + '?t=' + encodeURIComponent(token), {
        method: 'POST',
        signal: controller ? controller.signal : undefined
      })
        .then(function (response) {
          return response.json().catch(function () { return {}; }).then(function (body) {
            return { status: response.status, body: body };
          });
        })
        .then(function (res) {
          setBusy(false);
          if (res.body && res.body.success) {
            form.hidden = true;
            results.innerHTML = renderResults(res.body.data || {}, searchTerm);
            updateUrl(rawOrder);
            requestAnimationFrame(function () {
              results.querySelectorAll('.ryze-track__progress').forEach(function (el) {
                el.style.setProperty('--ryze-track-fill', el.dataset.fill);
              });
            });
            results.focus({ preventScroll: true });
            var top = root.getBoundingClientRect().top + window.pageYOffset - 24;
            if (top < window.pageYOffset) window.scrollTo({ top: top, behavior: 'smooth' });
            return;
          }

          results.hidden = true;
          results.innerHTML = '';
          if (res.status === 404) {
            showError("We couldn't find an order with that number and email. Check both match your confirmation email.", orderInput);
          } else if (res.status === 429) {
            showError('Too many attempts. Please wait a minute and try again.');
          } else {
            showError('Tracking is temporarily unavailable. Please try again in a moment.');
          }
        })
        .catch(function (error) {
          if (error && error.name === 'AbortError') return;
          setBusy(false);
          results.hidden = true;
          results.innerHTML = '';
          showError('We couldn\'t reach the tracking service. Check your connection and try again.');
        });
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (form.getAttribute('aria-busy') === 'true') return;
      lookup();
    });

    [orderInput, emailInput].forEach(function (input) {
      input.addEventListener('input', function () {
        if (input.getAttribute('aria-invalid') === 'true') clearError();
      });
    });

    results.addEventListener('click', function (event) {
      var target = event.target.closest('button');
      if (!target) return;

      if (target.hasAttribute('data-reset')) {
        showForm();
      } else if (target.hasAttribute('data-toggle-events')) {
        var list = document.getElementById(target.getAttribute('aria-controls'));
        var expanded = target.getAttribute('aria-expanded') === 'true';
        list.querySelectorAll('.ryze-track__event').forEach(function (row, i) {
          if (i >= VISIBLE_EVENTS) row.hidden = expanded;
        });
        target.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        target.textContent = expanded ? 'Show all ' + list.children.length + ' updates' : 'Show fewer updates';
      } else if (target.hasAttribute('data-copy')) {
        var label = target.querySelector('span');
        var code = target.dataset.copy;
        if (!navigator.clipboard) return;
        navigator.clipboard.writeText(code).then(function () {
          target.setAttribute('data-copied', '');
          label.textContent = 'Copied';
          setTimeout(function () {
            target.removeAttribute('data-copied');
            label.textContent = code;
          }, 1600);
        });
      }
    });

    // Prefill from ?order=…&email=… (e.g. links in shipping emails)
    var params = new URLSearchParams(window.location.search);
    if (params.get('order')) orderInput.value = params.get('order');
    if (params.get('email')) emailInput.value = params.get('email');
    if (orderInput.value && emailInput.value) lookup();
  }

  function initAll() {
    document.querySelectorAll('[data-ryze-track]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
